webpackJsonp([254022195166212],{

/***/ 786:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/404/","langKey":"ja"}}

/***/ })

});


// WEBPACK FOOTER //
// path---404-83850d01c017822398c5.js